var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ejs-pager',{staticClass:"e-gridpager",attrs:{"id":_vm.id,"click":_vm.onPagerClick,"drop-down-changed":_vm.dropDownChanged,"current-page":_vm.paging.page,"page-size":_vm.paging.pageSize,"page-count":_vm.paging.pageCount,"total-records-count":_vm.totalRecords,"page-sizes":_vm.currentPageSizes}})
}
var staticRenderFns = []

export { render, staticRenderFns }